import 'babel-polyfill';

import Vue from 'vue';
import App from './App';

import router from '@/app/router';
import store from '@/app/store';
import VuexRouterSync from 'vuex-router-sync';

import Axios from 'axios';

VuexRouterSync.sync( store, router );

Axios.defaults.baseURL = window._rootData.apiUrl;
Axios.defaults.headers.common.Accept = 'application/json';
Axios.interceptors.response.use(
    response => response,
    ( error ) =>
    {
        return Promise.reject( error );
    }
);

Vue.$http = Axios;
Object.defineProperty( Vue.prototype, '$http', {
    get()
    {
        return Axios;
    }
});

let fakeLive = getURLVar( 'live' );
if( fakeLive )
{
    fakeLive = fakeLive.split( '-' );
    store.dispatch( 'liveDatum', new Date( fakeLive[0], parseInt( fakeLive[1], 10 ) - 1, fakeLive[2], fakeLive[3], fakeLive[4], fakeLive[5] ) );
}

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});

function getURLVar( variable )
{
       let query = window.location.search.substring( 1 );
       let vars = query.split( '&' );
       for( let i = 0; i < vars.length; i++ )
       {
            let pair = vars[ i ].split( '=' );
            if( pair[ 0 ] === variable )
            {
                return pair[ 1 ];
            }
       }
       return false;
}
